export default __webpack_public_path__ + "static/media/eatingtimes_4@2x.23587c69.jpg";